// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"d019ff4d","142":"29e061d4","272":"726ae3a9","330":"f0395042","401":"34cb9184"}[chunkId] + ".chunk.css";
};